import React, { Fragment, useEffect, useState } from 'react';
import './home.scss';
import {
  AtresPieChart,
  AtresBarChart,
  TableCompare,
  Tag,
  Tags,
  ElTabs,
  Autocomplete,
  CustomMap,
  PactometroCheckSimple,
  PlacesProvider,
  getPlace,
  getExcludes,
  TYPES,
  SUBTYPES,
  ResultProvider,
  getResultOrigin,
  getData,
  ELECTION_SPAIN_GENERAL_EUROPE,
} from '@atresmedia/elections_modules_library';
import cintillos from '../../components/cintillo/cintillos';
import { InfoCintillo } from '../../components/cintillo/text';
import { getRoute, navigateTo } from '../../utils';

const PactosTxt =
  window.location.hostname
    .replace('localhost', 'lasexta')
    .indexOf('lasexta') === -1
    ? 'Pactos'
    : 'Pactómetro';

const InfoTxt = 'DATOS';

const addRoute = (data, place, community, excludes, reload) => {
  return data.map((town) => {
    const route = getRoute(town, community, excludes, reload);
    return { ...town, href: route };
  });
};

const Home = ({
  match,
  history,
  getHeader,
  onProvinceChange,
  onTownChange,
}) => {
  const {
    year,
    type,
    electionNumber,
    community,
    province,
    reload,
    placeId,
    chartType,
    town,
  } = match.params;

  const [allRegions, setAllRegions] = useState([]);
  const [selectedPlace, setSelectedPlace] = useState({});
  const [mapData, setMapData] = useState([]);

  const elSubtype = SUBTYPES.SINGLE;
  const [autocomple, setAutocomple] = useState('');
  const [communityName, setCommunityName] = useState('');
  const [autocomplePro, setAutocomplePro] = useState('');
  const [townName, setTownName] = useState('');
  const [provincePlace, setProvincePlace] = useState(null);
  const [excludes, setExcludes] = useState(null);

  const [resultOrigin, setResultOrigin] = useState({});
  const [lastYear, setLastYear] = useState();

  const tabsTitle =
    (type === TYPES.GENERAL && elSubtype === SUBTYPES.CONGRESS) ||
    type === TYPES.REGIONAL
      ? [InfoTxt, lastYear, PactosTxt]
      : [InfoTxt];

  // Hide label when we are at top level
  const showSelectedPlace = selectedPlace.ineId !== placeId;

  useEffect(() => {
    getResultOrigin(year, type, electionNumber, placeId)
      .then((historicResult) => {
        setResultOrigin(historicResult);

        setLastYear(String(historicResult.historic.year));
      })
      .catch((err) => {
        setLastYear('2016');
      });

    if (type === TYPES.GENERAL) {
      getPlace('typeplace=REGION&parentid=C108&size=1000').then((regions) => {
        setAllRegions(regions.content);
      });
    }
  }, [year, type, electionNumber, placeId]);

  useEffect(() => {
    getData(
      type === TYPES.REGIONAL
        ? province || placeId
        : province || community || placeId
    ).then((place) => {
      setSelectedPlace(place);
    });
  }, [community, province, type, placeId]);

  useEffect(() => {
    getData(town).then((place) => {
      setTownName(place.name);
    });
  }, [town]);

  useEffect(() => {
    getData(province).then((place) => {
      setProvincePlace(place);
    });
  }, [province]);

  useEffect(() => {
    Promise.all([
      getPlace(`sortby=main&size=60`),
      getPlace(`typeplace=PROVINCE&size=60`),

      getExcludes(type, electionNumber, year, community),
    ]).then(([data, places, _excludes]) => {
      const placesWithRoute = addRoute(
        places.content,
        data.content,
        community,
        _excludes,
        reload
      );

      setMapData(placesWithRoute);
      setExcludes(_excludes);
    });
    getData(community).then((place) => {
      setCommunityName(place.name);
    });
  }, [community, electionNumber, reload, type, year]);

  const goToDetails = (child, event) => {
    if (onProvinceChange) {
      event && event.preventDefault();

      return onProvinceChange(null, child, null, excludes);
    }
    if (!Boolean(parseInt(reload))) {
      if (event) {
        event.preventDefault();
        event.stopPropagation();
      }
      navigateTo(
        history,
        reload,
        `/${placeId}/${reload}/${year}/${type}/${electionNumber}/${chartType}/${child.grandpaId}/${child.parentId}/${child.ineId}/resultados.html`,
        child,
        community,
        excludes
      );
    }
  };

  const changeMapSelection = (parent, child, fromMap, event) => {
    if (onProvinceChange) {
      event.preventDefault();
      return onProvinceChange(parent, child, fromMap, excludes);
    }
    if (event && !Boolean(parseInt(reload))) {
      event.preventDefault();
      event.stopPropagation();

      if (community && child && child.ineId !== parent) {
        navigateTo(
          history,
          reload,
          `/${placeId}/${reload}/${year}/${type}/${electionNumber}/${chartType}/${child.parentId}/${child.ineId}/resultados.html`,
          child,
          !fromMap || community,
          excludes
        );
      } else if (parent && community !== parent) {
        navigateTo(
          history,
          reload,
          `/${placeId}/${reload}/${year}/${type}/${electionNumber}/${chartType}/${parent}/resultados.html`,
          child,
          !fromMap || community,
          excludes
        );
      }
    }
  };

  let Chart = chartType === 'arc' && !town ? AtresPieChart : AtresBarChart;
  let CurrentCintillo = cintillos[community];

  return (
    <Fragment>
      <div className={`mainWrapper pageHome chart_${chartType}`}>
        {resultOrigin && resultOrigin.primary ? (
          <ResultProvider
            active={resultOrigin.primary.active}
            year={year}
            type={type}
            subtype={elSubtype}
            electionPlace={placeId}
            electionNumber={electionNumber}
            placeId={town || province || community}
            details={Boolean(town)}
          >
            {(dataResult) => {
              return (
                <Fragment>
                  <div className="block">
                    {getHeader ? (
                      getHeader(community, dataResult)
                    ) : (
                      <CurrentCintillo
                        rightSide={
                          <InfoCintillo>
                            <div>
                              ESCRUTINIO:{' '}
                              <span>
                                {dataResult.currentCountPercent &&
                                  dataResult.currentCountPercent.replace(
                                    '.',
                                    ','
                                  )}
                                %
                              </span>
                            </div>
                            <div>
                              Actualizado:{' '}
                              <span>
                                {dataResult.updateDate &&
                                  dataResult.updateDate.slice(0, -3)}
                              </span>
                            </div>
                          </InfoCintillo>
                        }
                      ></CurrentCintillo>
                    )}
                    <div className="selectors_container">
                      <PlacesProvider
                        // name={autocomple}
                        type="PROVINCE"
                        parentId={community}
                      >
                        {(data) => {
                          return (
                            <React.Fragment>
                              {town ? (
                                <Fragment>
                                  <h3 class="town-title">{townName}</h3>
                                </Fragment>
                              ) : (
                                <Autocomplete
                                  results={[
                                    {
                                      ineId: '-1',
                                      name: `Todo ${communityName}`,
                                    },
                                    ...data.filter((d) => {
                                      return autocomple
                                        ? d.name
                                            .toLocaleLowerCase()
                                            .includes(
                                              autocomple.toLocaleLowerCase()
                                            )
                                        : d;
                                    }),
                                  ]}
                                  onChange={(value) => setAutocomple(value)}
                                  onSelect={(select) => {
                                    if (onProvinceChange) {
                                      let place =
                                        select.ineId > 0
                                          ? select
                                          : {
                                              parentId: community,
                                              grandpaId: ELECTION_SPAIN_GENERAL_EUROPE,
                                              name: communityName,
                                            };
                                      return onProvinceChange(
                                        null,
                                        place,
                                        null,
                                        excludes
                                      );
                                    }
                                    select.typePlace === 'REGION'
                                      ? navigateTo(
                                          history,
                                          reload,
                                          `/${placeId}/${reload}/${year}/${type}/${electionNumber}/${chartType}/${select.ineId}/resultados.html`,
                                          select,
                                          false,
                                          excludes
                                        )
                                      : navigateTo(
                                          history,
                                          reload,
                                          `/${placeId}/${reload}/${year}/${type}/${electionNumber}/${chartType}/${select.parentId}/${select.ineId}/resultados.html`,
                                          select,
                                          true,
                                          excludes
                                        );
                                    setAutocomple('');
                                  }}
                                  placeholder={'Busque provincia'}
                                  showArrow
                                  defaultValue={data.length > 0 && province}
                                />
                              )}
                            </React.Fragment>
                          );
                        }}
                      </PlacesProvider>
                      <PlacesProvider
                        // name={autocomplePro}
                        type="TOWN"
                        parentId={province}
                        grandParentId={province ? undefined : community}
                      >
                        {(data) => {
                          return (
                            <Autocomplete
                              results={[
                                ...data.filter((d) => {
                                  return autocomplePro
                                    ? d.name
                                        .toLocaleLowerCase()
                                        .includes(
                                          autocomplePro.toLocaleLowerCase()
                                        )
                                    : d;
                                }),
                              ]}
                              onChange={(value) => setAutocomplePro(value)}
                              onSelect={(select) => {
                                if (onProvinceChange)
                                  return onProvinceChange(
                                    null,
                                    select,
                                    null,
                                    excludes
                                  );

                                navigateTo(
                                  history,
                                  reload,
                                  `/${placeId}/${reload}/${year}/${type}/${electionNumber}/${chartType}/${select.grandpaId}/${select.parentId}/${select.ineId}/resultados.html`,
                                  select,
                                  true,
                                  excludes
                                );
                                setAutocomplePro('');
                              }}
                              placeholder={'Busque municipio'}
                              showArrow
                              defaultValue={data.length > 0 && town}
                            />
                          );
                        }}
                      </PlacesProvider>
                    </div>
                    <div className="graphs_container">
                      {town && (
                        <div className="graph_container graph_container__table">
                          <table className="infoTable">
                            <tbody>
                              <tr>
                                <td className="key">Votos contabilizados: </td>
                                <td className="value votes">
                                  {Number(dataResult.totalVotes).toLocaleString(
                                    'de'
                                  )}
                                </td>
                                <td className="value votes_percent">
                                  {Number(
                                    dataResult.currentCountPercent
                                  ).toLocaleString('de')}
                                  %
                                </td>
                              </tr>
                              <tr>
                                <td className="key">Abstenciones: </td>
                                <td className="value votes">
                                  {dataResult.abstentionVotes &&
                                    Number(
                                      dataResult.abstentionVotes
                                    ).toLocaleString('de')}
                                </td>
                                <td className="value abstention_percent">
                                  {Number(
                                    dataResult.abstentionPercent
                                  ).toLocaleString('de')}
                                  %
                                </td>
                              </tr>
                              <tr>
                                <td className="key">Votos en blanco: </td>
                                <td className="value whites">
                                  {Number(dataResult.whiteVotes).toLocaleString(
                                    'de'
                                  )}
                                </td>
                                <td className="value whites_percent">
                                  {Number(
                                    dataResult.whitePercent
                                  ).toLocaleString('de')}
                                  %
                                </td>
                              </tr>
                              <tr>
                                <td className="key">Votos nulos: </td>
                                <td className="value null">
                                  {Number(
                                    dataResult.invalidVotes
                                  ).toLocaleString('de')}
                                </td>
                                <td className="value null_percent">
                                  {Number(
                                    dataResult.invalidPercent
                                  ).toLocaleString('de')}
                                  %
                                </td>
                              </tr>
                              {dataResult.totalSeats > 0 && (
                                <tr>
                                  <td className="key">Total de escaños: </td>
                                  <td className="value votes">
                                    {Number(
                                      dataResult.totalSeats
                                    ).toLocaleString('de')}
                                  </td>
                                </tr>
                              )}
                            </tbody>
                          </table>
                          <p className="buttonBackContainer">
                            <a
                              href={
                                provincePlace &&
                                getRoute(
                                  provincePlace,
                                  community,
                                  excludes,
                                  reload
                                )
                              }
                              type="button"
                              className="tag button current"
                              onClick={(event) => {
                                if (onProvinceChange) {
                                  event.preventDefault();
                                  return onProvinceChange(
                                    null,
                                    provincePlace,
                                    null,
                                    excludes
                                  );
                                }
                              }}
                            >
                              Volver
                            </a>
                          </p>
                        </div>
                      )}

                      {!town && (
                        <div className="graph_container graph_container__map">
                          <Fragment>
                            <h2 className="selectedPlaceTitle">
                              <a
                                href={
                                  provincePlace &&
                                  getRoute(
                                    provincePlace,
                                    community,
                                    excludes,
                                    reload
                                  )
                                }
                                className="selectedCommunityTitle"
                                onClick={(event) => {
                                  if (onProvinceChange) {
                                    event.preventDefault();
                                    return onProvinceChange(
                                      null,
                                      {
                                        parentId: community,
                                        grandpaId: ELECTION_SPAIN_GENERAL_EUROPE,
                                      },
                                      null,
                                      excludes
                                    );
                                  }
                                }}
                              >
                                {communityName}
                              </a>
                              {showSelectedPlace && (
                                <span className="selectedTownTitle">
                                  {selectedPlace.name}
                                </span>
                              )}
                            </h2>
                            <CustomMap
                              allRegions={allRegions}
                              selectedPlace={selectedPlace}
                              partiesWinners={dataResult.partiesWinners || []}
                              native={true}
                              maps={mapData}
                              isRegional={type === TYPES.REGIONAL}
                              isFiltered={
                                type !== TYPES.REGIONAL
                                  ? Boolean(community)
                                  : Boolean(province)
                              }
                              currentCommunity={community}
                              onChange={changeMapSelection}
                            />
                          </Fragment>
                        </div>
                      )}

                      <div className="graph_container graph_container__chart">
                        {
                          <Chart
                            data={dataResult.partiesResult || []}
                            dataKey={town ? 'votesPercent' : 'seats'}
                            isSenate={elSubtype === SUBTYPES.SENATE}
                            showMajorityLine={
                              type !== TYPES.REGIONAL
                                ? !province && !community
                                : !Boolean(province)
                            }
                            showLabel
                            unitLabel={town ? 'votos' : null}
                            labelAbrv=""
                            seatTotal={
                              town
                                ? dataResult.totalVotes
                                : dataResult.totalSeats || 0
                            }
                          />
                        }
                      </div>
                    </div>
                    <div className="tabs_container">
                      <ElTabs
                        titles={
                          town
                            ? tabsTitle.filter((e) => e !== PactosTxt)
                            : tabsTitle
                        }
                      >
                        <TableCompare
                          className="current"
                          data={dataResult.partiesResult || []}
                          details={
                            elSubtype === SUBTYPES.CONGRESS ||
                            type === TYPES.REGIONAL
                          }
                          isSenate={elSubtype === SUBTYPES.SENATE}
                          hideSeats={town}
                          /* legend={
                            type === TYPES.GENERAL && [
                              '*Unidas Podemos: Podemos, IU, En Comú Podem y En Común-Unidas Podemos​',
                              'Más País: Más País, Més Compromís, Más País EQUO,  M País-CHA-EQUO',
                            ]
                          } */
                        />

                        <div>
                          <ResultProvider
                            active={
                              resultOrigin &&
                              resultOrigin.historic &&
                              resultOrigin.historic.active
                            }
                            year={
                              resultOrigin &&
                              resultOrigin.historic &&
                              resultOrigin.historic.year
                            }
                            type={type}
                            subtype={elSubtype}
                            electionPlace={placeId}
                            electionNumber={
                              resultOrigin &&
                              resultOrigin.historic &&
                              resultOrigin.historic.numElection
                            }
                            placeId={town || province || community}
                          >
                            {(oldData) => {
                              return (
                                <div class="graph_with_leyend">
                                  <Chart
                                    data={oldData.partiesResult || []}
                                    dataKey={town ? 'votesPercent' : 'seats'}
                                    isSenate={elSubtype === SUBTYPES.SENATE}
                                    showMajorityLine={
                                      type !== TYPES.REGIONAL
                                        ? !province && !community
                                        : !Boolean(province)
                                    }
                                    showLabel
                                    labelAbrv=""
                                    seatTotal={
                                      town
                                        ? dataResult.totalVotes
                                        : dataResult.totalSeats || 0
                                    }
                                    unitLabel={town ? 'votos' : null}
                                  />
                                  {community === 'R16' && (
                                    <p class="graph_leyend">
                                      *Los datos de PP y Cs (0 escaños) se
                                      representan sumados en 2016.
                                    </p>
                                  )}
                                </div>
                              );
                            }}
                          </ResultProvider>
                        </div>

                        {!town && (
                          <div className="pactometroWrapper">
                            <ResultProvider
                              active={
                                resultOrigin &&
                                resultOrigin.primary &&
                                resultOrigin.primary.active
                              }
                              year={
                                resultOrigin &&
                                resultOrigin.primary &&
                                resultOrigin.primary.year
                              }
                              type={type}
                              placeId={placeId}
                              subtype={
                                type === TYPES.GENERAL
                                  ? SUBTYPES.CONGRESS
                                  : SUBTYPES.SINGLE
                              }
                              electionPlace={placeId}
                              electionNumber={electionNumber}
                            >
                              {(generalData) => (
                                <div className="pactometroScroll">
                                  <PactometroCheckSimple
                                    totalSeat={generalData.totalSeats}
                                    seatData={generalData.partiesResult || []}
                                  />
                                </div>
                              )}
                            </ResultProvider>
                          </div>
                        )}
                      </ElTabs>
                    </div>
                    <div className="tags_container">
                      <Tags>
                        <PlacesProvider
                          type="TOWN"
                          grandParentId={!province ? community : null}
                          parentId={province || community}
                          size={
                            (window.innerWidth ||
                              document.documentElement.clientWidth ||
                              document.body.clientWidth) >= 720
                              ? 10
                              : 5
                          }
                          sortby="main"
                        >
                          {(data) =>
                            data &&
                            data.slice(0, 10).map((d) => (
                              <Tag
                                key={`${d.ineId}-${d.name}`}
                                onClick={(event) => {
                                  event.preventDefault();
                                  goToDetails(d, event);
                                }}
                                native
                                route={getRoute(d, true, excludes, reload)}
                              >
                                {d.name}
                              </Tag>
                            ))
                          }
                        </PlacesProvider>
                      </Tags>
                    </div>
                  </div>
                </Fragment>
              );
            }}
          </ResultProvider>
        ) : (
          <div>Loading</div>
        )}
      </div>
    </Fragment>
  );
};

export default Home;
